<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataTempKey="refInformTemp"
                    :userAuthorizeRole="
                        ['16', '17'].some(d => requestDocKeys.includes(d))
                            ? 'INFORM'
                            : ['02'].some(d => requestDocKeys.includes(d))
                            ? 'IMPORT_SAMPLE'
                            : ['18', '19'].some(d => requestDocKeys.includes(d))
                            ? 'PASS'
                            : 'Unknow'
                    "
                    :isLoading="isLoading"
                ></RequestorForm>
            </TabPane>
            <TabPane
                key="InformInfo"
                :tab="
                    ['16', '17'].some(d => requestDocKeys.includes(d))
                        ? $t('views.request.informInfo.title')
                        : ['02'].some(d => requestDocKeys.includes(d))
                        ? $t('views.request.import.title')
                        : ['18', '19'].some(d => requestDocKeys.includes(d))
                        ? $t('views.request.pass.titleIn')
                        : 'Unknow'
                "
                :forceRender="true"
            >
                <InformInfoForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refInformTemp"
                    :isLoading="isLoading"
                    :importExportDateTitle="['18', '19'].some(d => requestDocKeys.includes(d)) ? $t('views.request.informInfo.datePassIn') : null"
                    :refOriginDestinationCountryTitle="
                        ['18', '19'].some(d => requestDocKeys.includes(d))
                            ? $t('views.request.informInfo.country', { text: $t('views.request.informInfo.source') })
                            : null
                    "
                ></InformInfoForm>
            </TabPane>
            <TabPane
                v-if="['18', '19'].some(d => requestDocKeys.includes(d))"
                key="InformInfo2"
                :tab="$t('views.request.pass.titleOut')"
                :forceRender="true"
            >
                <InformInfoForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refInformTemp"
                    :isLoading="isLoading"
                    suffix="2"
                    :importExportDateTitle="$t('views.request.informInfo.datePassOut')"
                    :refOriginDestinationCountryTitle="$t('views.request.informInfo.country', { text: $t('views.request.informInfo.desc') })"
                ></InformInfoForm>
            </TabPane>
            <TabPane key="InformProduct" :tab="$t('views.request.informProduct.title')" :forceRender="true">
                <InformProductTab
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refInformTemp"
                    :isLoading="isLoading"
                    :request="data.useForm.modelRef"
                    :visibleCardTitle="true"
                ></InformProductTab>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    dataKey="refInformTemp"
                    :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { Card, Form, Tabs } from "ant-design-vue";
import { state as stateApp } from "../../../../app.logic";
import { createFormTitle, initForm, isLoading, onClickModalOk, initState } from "./request.logic";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
        InformInfoForm: defineAsyncComponent(() => import("./inform-info/InformInfoForm")),
        InformProductTab: defineAsyncComponent(() => import("./inform-product/InformProductTab")),
        AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
        RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "inform-requests" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false },
        requestDocKeys: { default: () => ["16", "17"] }
    },
    setup(props) {
        // eslint-disable-next-line vue/no-mutating-props
        //props.menuContext.tabKey = "InformProduct";
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const state = reactive(initState({ props }));
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, state, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
